import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import TextEdit from '~/services/textedit'
import timestamps from '~/services/timestamps'


export default class extends React.Component {
    static propTypes = {
		ID: PropTypes.number.isRequired,
		date: PropTypes.string.isRequired,
		link: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		read_time: PropTypes.number.isRequired,
		content: PropTypes.string.isRequired,
	};

    render() {

		return (
			<div className="search-result article">
				<div className="row">
					<div className="col-sm-6">
						<Link to={this.props.link}>
							<img src={this.props.images.banner} className="img-responsive" alt={this.props.title}/>
						</Link>
					</div>
					<div className="col-sm-6">
						<Link to={this.props.link}>
							<h3 className="mtop">
					    		{TextEdit.cutText(this.props.title, [80, 90])}
							</h3>
						</Link>
						<p>{ TextEdit.cutText(this.props.excerpt, 180) }</p>
						<div className="clearfix narrow-gutter">
							<div className="row ptop20">
								<div className="col-xs-2">
									<div className="profile-image" style={{backgroundImage: 'url(' + this.props.user.profile_picture + ')'}}></div>
								</div>
								<div className="col-xs-10">
									<h5 className="mtop0 mbot5">{this.props.user.first + ' ' + this.props.user.last}</h5>
									<p className="small">{'Posted ' + timestamps.timeSince(this.props.date, true)}</p>
									<p className="small">{this.props.read_time + ' min read'}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Search/components/ArticleResult.jsx